import {
  defineStore,
  getActivePinia,
} from 'pinia';
import { RouteRecordRaw } from 'vue-router';

import {
  useAccountInitPasswordStore,
  useAccountSettingStore,
} from '@/store';

export const loginRoutes: Array<RouteRecordRaw> = [
  {
    name: 'Login',
    component: () => import('@/components/pages/login/index.vue'),
    path: '/login',
    meta: {
      title: 'ログイン',
    },
    beforeEnter: (_, __, next) => {
      // TODO: ログイン状態でログイン画面に遷移した場合は取引履歴に遷移することで不要なリセットとUXを改善する
      const activePinia = getActivePinia();

      if (activePinia) {
        Object.entries(activePinia.state.value)
          .forEach(([
            storeName,
            state,
          ]) => {
            const storeDefinition = defineStore(storeName, state);
            const store = storeDefinition(activePinia);
            store.$reset();
          });
      }

      next();
    },
  },
  {
    name: 'LoginAuthEmail',
    component: () => import('@/components/pages/login/auth/email.vue'),
    path: '/login/auth/email',
    meta: {
      title: 'メール認証',
    },
  },
  {
    name: 'LoginPasswordChange',
    component: () => import('@/components/pages/login/password/change/index.vue'),
    path: '/login/password/change',
    meta: {
      title: 'パスワード変更',
    },
    beforeEnter: async () => {
      await useAccountSettingStore()
        .getAccountSetting();
    },
  },
  {
    name: 'LoginPasswordResetForgot',
    component: () => import('@/components/pages/login/password/forgot/index.vue'),
    path: '/login/password/forgot',
    meta: {
      title: 'パスワード再設定',
    },
  },
  {
    name: 'LoginPasswordResetMailSend',
    component: () => import('@/components/pages/login/password/forgot/mail-send.vue'),
    path: '/login/password/forgot/mail-send',
    meta: {
      title: 'パスワード再設定',
    },
  },
  {
    name: 'LoginPasswordReset',
    component: () => import('@/components/pages/login/password/forgot/reset.vue'),
    path: '/login/password/forgot/reset',
    meta: {
      title: 'パスワード再設定',
    },
    beforeEnter: async (to, _, next) => {
      await useAccountSettingStore()
        .getAccountSetting();

      const { token } = to.query;

      // クエリパラメータにtokenがあるか, stringかチェック
      if (token && typeof token === 'string') {
        next();
      } else {
        next({ name: 'Login', replace: true });
      }
    },
  },
  {
    name: 'LoginInitPassword',
    component: () => import('@/components/pages/login/init-password.vue'),
    path: '/login/init-password',
    meta: {
      title: 'パスワード初期化',
    },
    beforeEnter: (to, from, next) => {
      if (useAccountInitPasswordStore()
        .hasState()) {
        next();
      } else {
        next({ path: '/login', replace: true });
      }
    },
  },
];
